module.exports = __webpack_public_path__ + "img/v_clear.2b2184a1.svg";